module.exports = {"tube":{"":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/tube.json
// module id = 936
// module chunks = 108